<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="headline">
      <div>
        <span>{{ $tc("label.evidencias", 1) }}</span>
        <v-tooltip bottom v-if="habilitarUpload">
          <template v-slot:activator="{ on }">
            <v-btn class="ma-0" style="margin-top: -4px !important;" icon v-on="on" @click.stop="$refs.uploadArquivo.open()">
              <v-icon>attach_file</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("title.upload_evidencia") }}</span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div class="subtitle-2 mb-1">{{ $t("label.planejamento") }}</div>
      <list-files
        :habilitar-exclusao="false"
        ref="listFilesPlanejamento"
        :uri="uriPlanejamento"
        v-if="acao.idAcao"
      ></list-files>
      <div class="subtitle-2 mt-4 mb-1">{{ $tc("label.apuracao", 1) }}</div>
      <list-files
        @ListFiles_ITENS_ALTERADOS="itensAlterados"
        :habilitar-exclusao="habilitarUpload"
        ref="listFiles"
        :uri="uri"
        v-if="acao.idApuracao"></list-files>
    </v-expansion-panel-content>
    <upload-file-form
      v-if="habilitarUpload"
      ref="uploadArquivo"
      :title="$t('label.upload_evidencia')"
      :url="uriUpload"
      :auto-process-queue="false"
      @UPLOADFILE_SENDING="enviandoArquivo"
      @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
      @UploadArquivo__success="uploadSucesso">
      <v-text-field
        v-model="descricaoArquivo"
        :rules="[rules.required]"
        :counter="150"
        maxlength="150"
        :label="`${$t('label.descricao')}*`"
        required
      ></v-text-field>
    </upload-file-form>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateComputed } from '@/produto/common/functions/roles-computed-generator';
import basePath from '@/produto/common/functions/api-resource';
import ListFiles from '@/produto/shared-components/files/ListFiles';
import UploadFileForm from '@/produto/shared-components/upload/UploadFileForm';

export default {
  name: 'ApuracaoAcaoArquivos',
  props: {
    acao: Object,
    indHabilitaEvidenciaStatusAprovado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      esperar: false,
      descricaoArquivo: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  components: {
    UploadFileForm,
    ListFiles,
  },
  computed: {
    ...generateComputed('APU_ACAO', ['canEdit']),
    ...mapGetters('roles', ['getAllRoles']),
    canAddPagamentoManual() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter((el) => el === 'PAGAMENTO_MANUAL_CRUD').length;
    },
    canRegistrarNfApuracao() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter((el) => el === 'REGISTRAR_NF_APURACAO').length;
    },
    modoNfRestrito() {
      return this.canRegistrarNfApuracao && !this.canAddPagamentoManual;
    },
    modoPagamentoManualSaldoPendente() {
      return this.flagValidaSaldoPendente
        && this.canAddPagamentoManual
        && this.acao.statusApuracao === 'AGUARDANDO_APURACAO';
    },
    flagValidaSaldoPendente() {
      return this.acao && this.acao.indValidaSaldoPendente === true;
    },
    uri() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.acao.idAcao}/apuracao/${this.acao.idApuracao}`;
    },
    uriPlanejamento() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.acao.idAcao}`;
    },
    uriUpload() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.acao.idAcao}/apuracao/${this.acao.idApuracao}/upload`;
    },
    indAcaoFDC() {
      const isAcaoFDCNivel2 = this.acao && this.acao.tipo_acao && this.acao.tipo_acao.includes('FDC');
      const isAcaoFDCNivel3 = this.acao && this.acao.tipoAcao && this.acao.tipoAcao.includes('FDC');

      const isAcaoFDC = isAcaoFDCNivel2 || isAcaoFDCNivel3;

      return isAcaoFDC;
    },
    habilitarUpload() {
      const statusPermite = this.acao.statusApuracao === 'APURACAO_PREVIA'
        || this.acao.statusApuracao === 'AGUARDANDO_APURACAO'
        || this.acao.statusApuracao === 'EM_ANALISE'
        || this.indHabilitaEvidenciaStatusAprovado
        || (this.indAcaoFDC && this.acao.statusApuracao === 'VENCIDO');
      if (this.modoNfRestrito) {
        return this.acao.statusApuracao === 'AGUARDANDO_APURACAO';
      }
      if (this.modoPagamentoManualSaldoPendente) {
        return true;
      }
      return (this.canEdit || this.possuiAcessoClienteParaUpload()) && statusPermite;
    },
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      formData.append('descricao', encodeURI(this.descricaoArquivo));
    },
    itensAlterados(payload) {
      this.$emit('ApuracaoAcaoArquivos_itensAlterados', payload);
    },
    possuiAcessoClienteParaUpload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CLIENTE_APU_ACAO_CRUD').length;
    },
    preencherDescricaoComNomeArquivo(file) {
      this.descricaoArquivo = file.name;
    },
    uploadSucesso() {
      if (this.$refs.listFiles) {
        setTimeout(() => this.$refs.listFiles.refresh(), 1e3);
      }
      this.$toast(this.$t('label.upload_arquivo_sucesso'));
      this.$emit('ApuracaoAcaoArquivos_uploadSucesso');
    },
    arquivoRemovido() {
      if (this.$refs.listFiles.files.length === 1) {
        this.$emit('ApuracaoAcaoArquivos_arquivosRemovidos');
      }
    },
  },
  watch: {
    acao() {
      if (this.$refs.listFiles) {
        if (!this.esperar) {
          this.esperar = true;
          setTimeout(() => {
            if (this.$refs.listFiles) {
              this.$refs.listFiles.refresh();
            }
            if (this.$refs.listFilesPlanejamento) {
              this.$refs.listFilesPlanejamento.refresh();
            }
            this.esperar = false;
          }, 2e2);
        }
      }
    },
  },
};
</script>
